import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { PageVisibleState } from '../../metric/base-metric';
import { visibilityChangeObserver } from '../../observer/visibility-change-observer';
import { webVitalsObserver } from '../../observer/web-vitals-observer';
import { pageVisibleValue } from '../page-visible/value';
export var webVitalsMetrics = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(config, data, globalConfig) {
    var _globalConfig$webVita, _globalConfig$webVita2, _globalConfig$webVita3;
    var pageVisibleState, setPageVisibleStateToMixed, ttciEnabled, webVitalMetrics;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          pageVisibleState = data.pageVisibleState;
          setPageVisibleStateToMixed = function setPageVisibleStateToMixed() {
            pageVisibleState = PageVisibleState.MIXED;
          };
          visibilityChangeObserver.subscribe(setPageVisibleStateToMixed);
          ttciEnabled = ((_globalConfig$webVita = globalConfig.webVitals) === null || _globalConfig$webVita === void 0 ? void 0 : _globalConfig$webVita.ttciEnabled) !== undefined ? (_globalConfig$webVita2 = globalConfig.webVitals) === null || _globalConfig$webVita2 === void 0 ? void 0 : _globalConfig$webVita2.ttciEnabled : true;
          _context.next = 6;
          return webVitalsMetricCustomTimeout(ttciEnabled, ((_globalConfig$webVita3 = globalConfig.webVitals) === null || _globalConfig$webVita3 === void 0 ? void 0 : _globalConfig$webVita3.timeout) || 30000);
        case 6:
          webVitalMetrics = _context.sent;
          visibilityChangeObserver.unsubscribe(setPageVisibleStateToMixed);
          return _context.abrupt("return", _objectSpread(_objectSpread({}, webVitalMetrics), {}, {
            'pageVisible:state': pageVisibleState
          }, pageVisibleValue(config, data, globalConfig)));
        case 9:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function webVitalsMetrics(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

// exported to allow testing
export var webVitalsMetricCustomTimeout = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(ttciEnabled, timeout) {
    var timeoutWindow;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return ttciEnabled ? webVitalsObserver.ttciDetermined : Promise.resolve();
        case 2:
          // wait up to $timeout ms longer for web-vitals until returning
          timeoutWindow = new Promise(function (resolve) {
            return setTimeout(resolve, timeout);
          });
          _context2.next = 5;
          return Promise.race([timeoutWindow, webVitalsObserver.webVitalsDetermined]);
        case 5:
          return _context2.abrupt("return", webVitalsObserver.data);
        case 6:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function webVitalsMetricCustomTimeout(_x4, _x5) {
    return _ref2.apply(this, arguments);
  };
}();